module.exports = __webpack_public_path__ + "static/media/onbording-contractor-img.6e25dbc1.png";